// extracted by css-extract-rspack-plugin
export default {"accept-drop":"OtYJRJ","acceptDrop":"OtYJRJ","reject-drop":"kybTnQ","rejectDrop":"kybTnQ"};